<template>
  <v-dialog :value="true" persistent :max-width="maxWidth">
    <v-card>
      <div class="dialog-content">
        <h2 class="dialog-content__title">{{ item.title }}</h2>
        <p v-if="item.description">{{ item.description }}</p>
        <ul class="list">
          <OpeningHoursItem
            v-for="day in Object.values(dialogDays)"
            :key="day.id"
            :day="day"
            @trigger="checkDays(dialogDays)"
            :hoursRange="hoursRange"
          />
        </ul>
      </div>
      <div class="dialog-actions">
        <ui-button
          class="mx-2"
          color="primary"
          outlined
          :style="{ 'min-width': `${buttonWidth}px` }"
          @click="handleClose"
        >
          {{ $t("message.common.cancel") }}
        </ui-button>
        <ui-button
          class="mx-2"
          color="primary"
          :disabled="notValid"
          :style="{ 'min-width': `${buttonWidth * 2}px` }"
          @click="handleSaveClick(dialogDays)"
        >
          {{ $t("message.common.save") }}
        </ui-button>
      </div>
      <div v-if="!isMoreHoursVersion" class="dialog-footer">
        <v-icon class="mr-2" color="secondary">
          mdi-information-outline
        </v-icon>
        <p class="footer-description">
          {{ $t("message.facilityDetails.footer.openingHours") }}
        </p>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import OpeningHoursItem from "@/components/FacilityDetails/Dialog/OpeningHours/Item.vue";
import { generateHours } from "@/helpers/helpers";
import { regex } from "@/config/regex";

export default {
  name: "FacilityDetailsOpeninigHoursDialog",
  components: {
    OpeningHoursItem
  },
  props: {
    days: {
      type: Object,
      default: () => {}
    },
    maxWidth: {
      type: Number,
      default: 500
    },
    item: {
      type: Object,
      default: () => {
        return {
          title: ""
        };
      }
    },
    isMoreHoursVersion: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      notValid: false,
      hoursRange: [],
      buttonWidth: 115,
      dialogDays: JSON.parse(JSON.stringify(this.days))
    };
  },
  created() {
    this.hoursRange = generateHours();
    this.checkDays(this.dialogDays);
  },
  methods: {
    validate(item) {
      if (!item) return false;

      const match = item ? item.match(regex.timeFormat) : null;
      return match && !!match[0];
    },

    handleClose() {
      this.dialogDays = JSON.parse(JSON.stringify(this.days));

      this.$emit("close");
    },

    checkDays(days) {
      let fullArr = [];

      for (const day of Object.values(days)) {
        const dayArr = day.value.flat();
        fullArr.push(dayArr);
      }

      let flatten = fullArr.flat();

      let isNotValid = flatten.some(item => this.validate(item) === false);

      if (isNotValid) {
        this.notValid = true;
        fullArr = [];
        return;
      }

      fullArr = [];
      this.notValid = false;
    },

    handleSaveClick(days) {
      this.checkDays(days);

      if (!this.notValid) {
        return this.$emit("save", { ...days });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  margin-top: $spacing * 5;
  padding: 0;
}

.dialog-content {
  padding: $spacing * 5 $spacing * 7.5;
}

.dialog-content__title {
  @include font-size(16px);
  text-align: center;
  font-weight: $font-weight-semi-bold;
}

.dialog-actions {
  display: flex;
  justify-content: center;
  padding: $spacing * 2.5 0;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  margin: 0 auto;
  padding: $spacing * 4 0;
}

.footer-description {
  @include font-size(14px);
  margin-bottom: 0;
}
</style>
